import { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Menu } from "semantic-ui-react";
import AppContext, { token_config } from '../AppContext';
import AxiosInstance from '../helpers/axiosInstance';

const NavMobile = ({ isOpen }: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setAuthTokens, userInfo, handleShowNav } = useContext(AppContext);
  const privileges: string[] = userInfo ? userInfo.Privileges.split(',') : [];

  const classNameNav = isOpen ? "nav-mobile is--open" : "nav-mobile";

  const handleSignOut = async () => {
    handleShowNav();
    try {
      await AxiosInstance.get('/Auth/SignOut');
    } catch (error) {
      console.error(error);
    } finally {
      localStorage.removeItem(token_config.ACCESS_TOKEN);
      localStorage.removeItem(token_config.REFRESH_TOKEN);
      setAuthTokens(null);
      navigate('/');
    }
  }

  return (
    <Menu pointing secondary vertical={true} className={classNameNav}>
      <Menu.Item
        name="Cases"
        active={location.pathname === '/dashboard' || location.pathname.indexOf('/case') !== -1}
        onClick={() => {
          handleShowNav();
          navigate('/dashboard');
        }}
      />
      <Menu.Item
        name="Constituents"
        active={location.pathname === '/constituents' || location.pathname.indexOf('/constituent') !== -1}
        onClick={() => {
          handleShowNav();
          navigate('/constituents');
        }}
      />
      <Menu.Item
        name="Reports"
        active={location.pathname === '/reports'}
        onClick={() => {
          handleShowNav();
          navigate('/reports');
        }}
      />
      <Menu.Item
        name="Settings"
        onClick={() => {
          handleShowNav();
          navigate(privileges.includes(token_config.MANAGE_USERS) ? '/users' : '/contact-form');
        }}
      />
      <Menu.Item
        name="Logout"
        onClick={handleSignOut}
      />
    </Menu>
  );
};

export default NavMobile;
